
<div class="inner-adjust">
    <h2>{{typeDeSortDisplay}}</h2>

    <div class="row">
      <div class="col-3"><span class="label">Crimsons disponible: </span>{{personnage?.crimsonDisponible}}</div>
      <div class="col-3"><span class="label">Case de compétences disponible: </span>{{personnage?.achatDisponible}}</div>
      <div class="col-3"><span class="label">Points d'achat disponible: </span>{{personnage?.achatSortDisponible}}
        <button [disabled]="!canAddAchatSort()" (click)="AddAchatSort()">+</button>
        <button [disabled]="!canRemoveAchatSort()" (click)="RemoveAchatSort()">-</button>
      </div>
    </div>


    <div class="row">
      <form [formGroup]="addSortForm" (ngSubmit)="onSubmit()">
        <div class="col-9 form-group">
          <ng-select [items]="availableSorts" bindLabel="nom" bindValue="id" formControlName="addedSortId">
            <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
              <div class="select-title">
                {{item.nom}} - Niveau {{item.niveau}} - {{item.cout}} <span *ngIf="item.cout <= 1">point </span><span *ngIf="item.cout > 1">points </span>d'essence
              </div>
              <div class="description">{{item.description}}</div>
              <div class="avertissement">{{item.avertissement}}</div>
            </ng-template>
          </ng-select>
          <div *ngIf="submitted && f['addedSortId'].errors" class="invalid-feedback">
              <div *ngIf="f['addedSortId'].errors['required']">Talent requis</div>
          </div>
        </div>
        <div class="col pt-2">
            <input type="submit" value="Ajouter le talent" class="btn btnPrimary" >
        </div>
    </form>
  </div>

  <div *ngFor="let item of [].constructor(3); let i = index">
    <h2>Niveau {{i+1}}</h2>


    <div class="row pb-2" *ngFor="let sort of getSortsPersonnage(i+1)">
      <div class="col-9">
        <h3>{{sort.nom}}</h3>
        <div class="description">{{sort.description}}</div>
        <div class="avertissement">{{sort.avertissement}}</div>
      </div>
      <div class="col">
        <button [disabled]="!canRemoveSort(sort)" (click)="removeSort(sort)">Retirer</button>
      </div>
    </div>
  </div>
</div>